<!-- 我的订单item -->
<template>
  <div class="order-item">
    <div class="order-item-top">
      <span class="order_number">
        {{order.order_cate_number}}
        <span v-if="+order.from_replace_member_id" class="tag">代下单</span>
      </span>
      <span
        :style="{color:~[3,4].indexOf(+order.order_state) ? '#999999' : '#F53737'}">
        {{getState}}
      </span>
    </div>
    <ul class="order-item-goods-across" v-if="order.goods_list.length>1">
      <li
        v-for="goods in order.goods_list.slice(0,4)"
        :key="goods.order_goods_id"
        @click="toDetails(order.order_cate_number)">
        <img :src="goods.thumb_img || $notImg"/>
        <span>x{{parseInt(goods.quantity)}}</span>
      </li>
      <li class="right-circle-wrap"><cc-svg-icon size="21px" @click="toDetails(order.order_cate_number)" class-name="right-circle" icon-class="right-circle" /></li>
    </ul>
    <ul class="order-item-goods-vertical"
      v-else
      @click="toDetails(order.order_cate_number)">
      <li v-for="goods in order.goods_list" :key="goods.order_goods_id">
        <div class="goods_img">
          <img :src="goods.thumb_img || $notImg" alt="">
        </div>
        <div class="goods_info">
          <div>
            <p class="font1">{{goods.general_name}} {{goods.norms}} {{goods.produce_unit}}</p>
            <p class="font2">数量：{{parseInt(goods.quantity)}}</p>
          </div>
          <p><span class="red">￥{{goods.bid_price}}</span></p>
        </div>
      </li>
    </ul>
    <div class="order-item-info">
      <div class="tr mt10">
        <span class="mr20">{{order.goods_list.length}}种商品</span>
        <span>应付总额：</span>
        <span class="price money">￥{{order.priced}}</span>
      </div>
      <div class="tr mt10">
        <span>预估提成：</span>
        <span class="money">￥{{order.order_feedback_money}}</span>
      </div>
    </div>
    <div class="order-item-bottom" v-if="~[0,5].indexOf(+order.order_state)">
      <!-- 待审核和待受理状态支持弃单操作 -->
      <span v-if="~[0,5].indexOf(+order.order_state)" class="btn cancel" @click="showCancelOrder = true">弃单</span>
      <!-- 待审核状态支持改价操作 在线支付不支持改价 -->
      <span v-if="+order.order_state === 5 && +order.payment_method !== 1" class="btn edit" @click="editPrice(1)">改价</span>
      <!-- 待审核状态支持审核订单 -->
      <span v-if="+order.order_state === 5" class="btn accept" @click="acceptOrder(1)">审核</span>
    </div>
    <van-dialog
      v-model="showCancelOrder"
      title="弃单"
      class="van-dialog"
      show-cancel-button
      @confirm="confirmCancelOrder"
    >
      <div class="cancel-order-dialog">
        <p>弃单后订单将无法恢复，确定弃单</p>
        <input type="text" v-model="cancel_order_message" placeholder="请填写弃单理由">
      </div>
    </van-dialog>
  <edit-price-popup @loadData="loadData" :show.sync="showPopup" :orderNumber="order.order_cate_number" v-model="order.goods_list"/>
  </div>
</template>

<script>
import EditPricePopup from './edit-price-popup'
import { editOrderState } from '~fetch/manage-center/myorder'
import { ResultCode } from '~const/ResultCode'
import Vue from 'vue'
import { Dialog, Toast } from 'vant'
Vue.use(Dialog)
  .use(Toast)
export default {
  components: {
    EditPricePopup
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data () {
    return {
      showCancelOrder: false,
      showPopup: false,
      order: this.item,
      cancel_order_message: ''// 弃单理由
    }
  },

  computed: {
    getState () {
      const states = ['待受理', '拣货中', '', '已取消', '已完成', '待审核']
      let stateName = ''
      if (+this.order.order_state === 1) {
        if (+this.order.logis_state === 0) {
          stateName = '拣货中'
        } else {
          stateName = '已发货'
        }
      } else {
        stateName = states[+this.order.order_state]
      }
      return stateName
    }
  },

  created () {
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler () {
        this.order = this.item
      }

    }
  },
  methods: {
    loadData (data) {
      this.order.priced = data.sum_price
      this.order.order_feedback_money = data.sum_feedback_money
      this.order.goods_list.forEach(item => {
        data.goods_list.forEach(goods => {
          if (item.goods_id === goods.goods_id) {
            item.bid_price = goods.bid_price
          }
        })
      })
    },
    /**
    *@description 去详情页
    */
    toDetails (id) {
      this.$router.push({
        path: '/myorder-details?id=' + id
      })
    },
    /**
     * @description 修改价格
     */
    editPrice () {
      this.showPopup = true
    },
    /**
     * @description 审核订单
     */
    acceptOrder () {
      Dialog.confirm({
        title: '审核订单',
        className: 'order-dialog',
        message: '确定审核订单？审核订单后将不能改价。'
      }).then(() => {
        // on confirm
        this.changeOrderState(1, '审核成功')
      }).catch(() => {
        // on cancel
      })
    },
    postAcceptOrder () {

    },

    confirmCancelOrder () {
      this.changeOrderState(3, '弃单成功')
    },
    /**
     * @description 修改订单状态
     * @param {Number} state 1 审核订单 3 弃单
     * @param {String} msg 请求成功信息
     */
    async changeOrderState (state, msg) {
      const params = {
        order_cate_number: this.order.order_cate_number,
        order_number: this.order.order_number,
        order_state: state,
        order_cate_id: this.order.id
      }
      if (state === 3) {
        params.cancel_order_message = this.cancel_order_message
      }
      let { status, info } = await editOrderState(params)
      if (status === ResultCode.SUCCESS) {
        if (state === 1) {
          this.order.order_state = 0
        } else {
          this.order.order_state = 3
        }
        Toast(msg)
      } else {
        Toast(info.msg)
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.order-item{
  color: #333333;
  background: #ffffff;
  margin-bottom: 8px;
  box-shadow: $box-shadow-base;
  &-top{
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    border-bottom: 1px solid $border-color-base;
  }
  &-goods-across{
    height: 80px;
    padding: 10px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid $border-color-base;
    li{
      width: 60px;
      height: 60px;
      float: left;
      margin-right: 13px;
      // border: 1px solid $border-color-base;
      position: relative;
      img{
        width: 100%;
      }
      span{
        background:rgba(31,31,31,1);
        width: 23px;
        height: 12px;
        opacity: 0.6;
        border-radius: 5px 0 0 5px;
        color: #ffffff;
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
      }
    }
  }
  &-goods-vertical{
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid $border-color-base;
    li{
      display: flex;
      justify-content: flex-start;
      margin-bottom: 14px;
      .goods_img{
        width: 60px;
        height: 60px;
        box-sizing: border-box;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .goods_info{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;
        width: 285px;
      }
    }
  }
  &-info{
    height: 53px;
    border-bottom: 1px solid $border-color-base;
    padding: 0 10px;
    font-size: 12px;
    .money{
      display: inline-block;
      width: 69px;
      text-align: right;
    }
  }
  &-bottom{
    padding: 0 10px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn{
      padding: 6px 14px;
      border-width: 1px;
      border-style: solid;
      border-color: red;
      margin-left: 10px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .accept{
      border-color:var(--APP_theme_color);
      background:  var(--APP_theme_color);
      color: #ffffff;
    }
    .cancel{
      border-color: #D2D2D2;
      color: #777777;
    }
    .edit{
      border-color: var(--APP_theme_color);
      color: var(--APP_theme_color);
    }
  }
}
.price{
  color: #F53737;
}
.right-circle-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0!important;
  float: right!important;
  border: none!important;
  color: #DCDCDC;
}
.cancel-order-dialog{
  padding: 15px 40px 20px;
  p{
    color: #666666;
    font-size: 15px;
  }
  input{
    width: 238px;
    height: 30px;
    border: 1px solid #EEEEEE;
    margin-top: 15px;
    padding-left: 5px;

  }
}

.van-dialog{
  /deep/{
    .van-dialog__confirm{
      color: var(--APP_theme_color);
    }
    .van-dialog__header{
      font-weight: 600;
      padding-top: 10px;
    }
  }

}

.tag{
  color: var(--APP_theme_color);
  border: 1px solid var(--APP_theme_color);
  display: inline-block;
  padding: 2px 3px;
  border-radius: 2px;
  margin-left: 3px;;
}
</style>
<style lang="scss">
.order-dialog{
  .van-dialog__header{
        font-weight: 600;
        padding-top: 10px;
      }
}
</style>
